import api from "./api";

// Función para obtener los detalles del usuario
export const getUserDetails = async () => {

    try{
        const response = await api.get("/user/details/");
        return response.data;
    }
    catch(error){
        console.error("Error al obtener detalles del usuario:", error);
        return null;
    }
}

// Función para obtener el nombre del usuario
export const getUserName = async () => {

    try{
        const response = await api.get("/user/name/");
        return response.data;
    }
    catch(error){
        console.error("Error al obtener detalles del usuario:", error);
        return null;
    }
}